import { render } from "./DisabledButton.vue?vue&type=template&id=627eeb16"
import script from "./DisabledButton.vue?vue&type=script&lang=js"
export * from "./DisabledButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__